module.exports = __webpack_public_path__ + "img/Codepen-black.188ac7be.svg";